import convert from "convert-units";
import round from "lodash/round";
import React from "react";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";

const UNITS = {
  metric: "kg",
  imperial: "lb",
};

const RPE_INTENSITY_COLORS = [
  "#2787F5",
  "#5BC500",
  "#FFD400",
  "#FF8800",
  "#ED0A34",
  "#FFFFFF",
];

function DaylyWorkoutHeader({
  activeUser,
  query,
  openQuickEditMode,
  handleRemove,
  dailyStats,
  activeDay,
}) {
  const unit = activeUser.units;
  let sessionRPE,
    readinessRate,
    intensityColor,
    bodyMeasurements,
    bodyWeight = null,
    stepCount = null;

  if (dailyStats) {
    sessionRPE = dailyStats.sessionRPE || null;

    intensityColor = sessionRPE
      ? RPE_INTENSITY_COLORS[Math.trunc(sessionRPE - 5)]
      : null;

    readinessRate = dailyStats.readiness
      ? Object.values(dailyStats.readiness).reduce((a, b) => a + b, 0)
      : null;

    bodyWeight = dailyStats.bodyWeight
      ? unit === "metric"
        ? dailyStats.bodyWeight
        : round(convert(dailyStats.bodyWeight).from("kg").to("lb"), 1)
      : null;

    bodyMeasurements = Boolean(dailyStats.bodyMeasurements);
    stepCount = Number(dailyStats.steps) || null;
  }

  const RPEProps = intensityColor
    ? {
        style: {
          color: intensityColor,
        },
      }
    : {};

  const { athlete, organizationCoach = undefined } = query;

  const organizationCoachParam = organizationCoach
    ? `&organizationCoach=${organizationCoach}`
    : "";
  const urlStart = athlete ? "/athlete-portal/metrics" : "/dashboard/metrics";
  const athleteParam = athlete ? `&athlete=${athlete}` : "";
  const urlEnd = athleteParam + organizationCoachParam;
  const formatedDate = activeDay.format("YYYY-MM-DD");

  return (
    <header>
      <hgroup>
        <a
          href={`${urlStart}/readiness-rate?view=day&date=${formatedDate}${urlEnd}`}
        >
          Readiness rate
          <span>{readinessRate ? `${readinessRate} / 25` : "--"}</span>
        </a>
        <a
          href={`${urlStart}/session-rpe?view=day&date=${formatedDate}${urlEnd}`}
        >
          Session RPE
          <span {...RPEProps}>{dailyStats ? dailyStats.sessionRPE : "--"}</span>
        </a>
        <a
          href={`${urlStart}/bodyweight?view=day&date=${formatedDate}${urlEnd}`}
        >
          Bodyweight
          <span>
            {bodyWeight ? `${round(bodyWeight, 1)}${UNITS[unit]}` : "--"}
          </span>
        </a>
        <a
          href={`${urlStart}/step-count?view=day&date=${formatedDate}${urlEnd}`}
        >
          Step Count
          <span>{stepCount ? stepCount : "--"}</span>
        </a>
      </hgroup>

      <hgroup>
        <ToolTip id="quick-edit-workout" body="Quick Edit">
          <a
            onClick={openQuickEditMode}
            href="#_"
            data-button-type="secondary"
            role="button"
            className="px-[0.35rem] h-8"
          >
            <SvgIcon src="/img/new-icons/edit-pencil.svg" />
          </a>
        </ToolTip>

        <ToolTip id="delete-workout" body="Delete Workout">
          <a
            href="#_"
            onClick={handleRemove}
            data-button-type="secondary"
            role="button"
            className="px-[0.35rem] h-8"
          >
            <SvgIcon
              src="/img/new-icons/red-trash.svg"
              noFilterOnLight={true}
            />
          </a>
        </ToolTip>

        <a
          data-button-type="primary"
          role="button"
          href={`/actions/refresh?modal[type]=calendar-add-exercise&day=${query.date}`}
        >
          <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
          Add Exercise
        </a>
      </hgroup>
    </header>
  );
}

export default DaylyWorkoutHeader;
